import React from 'react';
import _ from 'lodash';
import { DASHBOARD_SHOW } from 'src/constants/EndpointUrls';

const SUPPORT_LINK = 'https://jobcan-payroll.zendesk.com/hc/ja/requests/new';

const ERROR_DISPLAY_MAPPING = {
  not_found: {
    title: 'The page is not found.',
    description: 'The page have been changed or delete.'
  },
  internal_server_error: {
    title: 'The page is not found.',
    description: (
      <span>
        If you cannot access the page for a while, please contact.
      </span>
    )
  },
  bad_request: {
    title: 'The page is not found.',
    description: 'The page have been changed or delete.'
  },
  forbidden: {
    title: 'The page is not found.',
    description: 'The page have been changed or delete.'
  },
  unprocessable_entity: {
    title: 'The page is not found.',
    description: (
      <span>
        If the problem persists, please contact our support team.
      </span>
    )
  }
};

const ErrorPage = ({ errorStatus, errorMessage, t }) => {
  const error = _.get(ERROR_DISPLAY_MAPPING, errorStatus) || ERROR_DISPLAY_MAPPING.not_found;
  if (errorMessage) {
    error.description = errorMessage;
  }
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{error.title}</h1>
      </div>
      <div className="l-wrap-xs u-pt100">
        <div className="l-box-message">
          <p>
            {error.description}
            <br />
            <br />
            <a href={DASHBOARD_SHOW} className="u-txt-link">
              Go back to dashboard.
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
